export const LOCAL_STORAGE_KEY = {
  userInfo: 'user_info',
  token: 'token',
  refreshToken: 'refresh_token',
};

export const SESSION_STORAGE_KEY = {
  loginSession: 'login_session',
  userId: 'user_id',
  roleId: 'role_id',
  userAvatar: 'user_avatar',
  userInfo: 'user_info',
  userClasses: 'user_classes',
  accessToken: 'access_token',
  refreshToken: 'refresh_token',
};
